import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FormHelper } from '@forms';
import { UserService } from '@user';
import { HttpHelperService } from '@http';
import { __i18n, LanguageService } from '@localisation';
import { ThemeService } from '@themes';
import { Config } from '@config';


@Component({
    selector: 'reset-password',
    templateUrl: './reset.password.template.html',
    standalone: false
})
export class ResetPasswordComponent implements OnDestroy, OnInit {
    constructor(
        private formBuilder: FormBuilder,
        private formHelper: FormHelper,
        private user: UserService,
        private httpHelper: HttpHelperService,
        private config: Config,
        private languageService: LanguageService
    ) {
        this.changePasswordForm = this.formBuilder.group({
            email : ['', Validators.compose([Validators.required, Validators.email]) ]
        });
        if (location.hash == '#/ResetPasswordExt') {
            this.externalLoginLink = this.config.externaLoginLink + this.config.serverConfig.EXT_AUTH_TYPE + '&locale=' + this.languageService.language;
        }
    }

    public changePasswordForm: FormGroup;

    public resetError: string;

    public mailIsSended: boolean = false;

    public resetPasswordButtonState: string;

    private externalLoginLink: string;

    private _handlePopStateBound = this.handlePopState.bind(this);

    ngOnInit() {
        if (this.externalLoginLink) {
            history.replaceState({goToExternalLogin: true}, "", "#/Externallogin");
            history.pushState(null, "", "#/ResetPassword");
            window.addEventListener('popstate', this._handlePopStateBound);
        }
    }

    ngOnDestroy() {
        window.removeEventListener('popstate', this._handlePopStateBound);
    }

    handlePopState(e: PopStateEvent) {
        if (e.state?.goToExternalLogin) {
            e.preventDefault();
            e.stopPropagation();
            window.location.href = this.externalLoginLink;
        }
    }

    public async resetPassword(){
        this.resetError = null;
        this.formHelper.markFormGroupTouched(this.changePasswordForm);

        if(this.changePasswordForm.valid) {
            this.resetPasswordButtonState = 'loading';
            try {
                const result = await this.user.resetPassword({
                    email: this.changePasswordForm.controls.email.value
                });
                this.mailIsSended = true;
            }catch(e) {
                this.resetError = this.httpHelper.getErrorMessage(e)
                    || __i18n('The password could not be changed, an error occurred.', 'landingpage.changepassword.error');
            } finally {
                this.resetPasswordButtonState = 'loaded';
            }
        }
    }
}